<template>
  <el-container direction="vertical">
    <Header></Header>
    <MainContainer></MainContainer>
    <Footer></Footer>
  </el-container>
</template>
<script>
import Header from '@/components/merchants/Header';
import MainContainer from '@/components/merchants/MainContainer';
import Footer from '@/components/merchants/Footer';

export default {
  name: 'Merchants',
  methods: {
    track () {
      this.$ga.page('/')
    }
  },
  metaInfo () {
    return {
      title: this.$t('meta.title'),
      meta: [
        { charset: this.$t('meta.content-type') },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        {
          'name': 'title',
          'content': this.$t('meta.title'),
          'vmid': 'name'
        },
        {
          'name': 'description',
          'content': this.$t('meta.description'),
          'vmid': 'description'
        },
        {
          'name': 'image',
          'content': 'https://www.cryptocompra.com/static/favicon/cryptocompra.png',
          'vmid': 'image'
        },
        {
          'property': 'og:title',
          'content': this.$t('meta.title'),
          'vmid': 'og:title'
        },
        {
          'property': 'og:description',
          'content': this.$t('meta.description'),
          'vmid': 'og:description'
        },
        {
          'property': 'og:image',
          'content': 'https://www.cryptocompra.com/static/favicon/cryptocompra.png',
          'vmid': 'og:image'
        },
        {
          'property': 'og:type',
          'content': 'website',
          'vmid': 'og:type'
        },
        {
          'property': 'og:url',
          'content': 'https://www.cryptocompra.com/'+this.$store.getters['lang/getLang'],
          'vmid': 'og:url'
        },
        {
          'property': 'og:site_name',
          'content': 'CryptoCompra by CryptoMarket',
          'vmid': 'og:site_name'
        },
        {
          'name': 'twitter:title',
          'content': this.$t('meta.title'),
          'vmid': 'twitter:title'
        },
        {
          'name': 'twitter:description',
          'content': this.$t('meta.description'),
          'vmid': 'twitter:description'
        },
        {
          'name': 'twitter:card',
          'content': 'summary',
          'vmid': 'twitter:card'
        },
        {
          'name': 'twitter:image',
          'content': 'https://www.cryptocompra.com/static/favicon/cryptocompra.png',
          'vmid': 'twitter:image'
        },
        {
          'name': 'twitter:image:alt',
          'content': this.$t('meta.description'),
          'vmid': 'twitter:image:alt'
        },
        {
          'name': 'twitter:site',
          'content': (this.$store.getters['lang/getLang'] === 'pt-BR') ? '@cryptomktbrasil':'@CryptoMKT',
          'vmid': 'twitter:image'
        },
        { name: 'description', content: this.$t('meta.description') }
      ]
    }
  },
  components: { Header, MainContainer, Footer },
};
</script>
<style scoped>
/*sm and down*/
@media only screen and (max-width: 992px) {

  main{
    /* margin-top: 17vh !important; */
  }
}
main{
  /* padding-top: 0 */
}
</style>



// WEBPACK FOOTER //
// src/components/Merchants.vue